module.exports = __webpack_public_path__ + "static/media/background.a6358f87.jpg";